import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import ServicesPreview from './components/ServicesPreview/ServicesPreview';
import WorkflowSection from './components/WorkflowSection/WorkflowSection';
import FAQ from './components/FAQ/FAQ';
import Services from './components/Services/Services';
import Portfolio from './components/Portfolio/Portfolio';
import Blog from './components/Blog/Blog';
import AboutUs from './components/AboutUs/AboutUs';
import BlogDetail from './components/BlogDetail/BlogDetail';
import TermsConditions from './components/TermsConditions/TermsConditions';
import Privacy from './components/Privacy/Privacy';
import ClaimsBook from './components/ClaimsBook/ClaimsBook';
import Budget from './components/Budget/Budget';
import Footer from './components/Footer/Footer';
import CookieBanner from './components/CookieBanner/CookieBanner';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop /> 
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <ServicesPreview />
              <WorkflowSection />
              <FAQ />
            </>
          } />
          <Route path="/servicios" element={<Services />} />
          <Route path="/trabajos" element={<Portfolio />} />
          <Route path="/nosotros" element={<AboutUs />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/terminos" element={<TermsConditions />} />
          <Route path="/privacidad" element={<Privacy />} />
          <Route path="/reclamaciones" element={<ClaimsBook />} />
          <Route path="/presupuesto" element={<Budget />} />
        </Routes>
        <Footer />
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;
